import { type NurseSenkaTheme } from '../../types/NurseSenkaTheme';

import {
  knowledgeWebUrl,
  loungeWebUrl,
  portalWebUrl,
  squareWebUrl,
  workplaceReputationWebUrl,
} from './baseUrl';

import { type AppEnv, HttpsUrl } from '@/packages/nurse-senka-frontend-sdk';

export const generateServiceLogoUrlFromTheme = (
  theme?: NurseSenkaTheme,
  appEnv?: AppEnv,
): HttpsUrl => {
  if (theme && appEnv) {
    switch (theme.id) {
      case 'default':
        return portalWebUrl(appEnv);
      case 'knowledge':
        return knowledgeWebUrl(appEnv);
      case 'square':
        return squareWebUrl(appEnv);
      case 'lounge':
        return loungeWebUrl(appEnv);
      case 'working':
        return workplaceReputationWebUrl(appEnv);
      default:
        return portalWebUrl(appEnv);
    }
  }

  return appEnv ? portalWebUrl(appEnv) : portalWebUrl('production');
};
